export const pt = {
  title: {
    main: "PROMPT",
    sub: "NINJA",
    remote: "CONTROLE",
  },
  common: {
    sync: "Sincronizar",
    refresh: "Atualizar",
    save: "Salvar",
    cancel: "Cancelar",
    more: "Mais opções...",
    less: "Menos",
    delete: "Excluir",
    reconnect: "Reconectar",
    app_name: "PromptNinja",
  },
  menu: {
    home: "Início",
    features: "Recursos",
    pricing: "Preços",
    backToHome: "Voltar para Página Inicial",
    validate: "Validar",
    validateLicense: "Validar Licença",
    start: "Iniciar",
    startHint: "Aperte PLAY para começar",
    startHintShort: "Aperte PLAY",
  },
  landing: {
    meta: {
      title: "PromptNinja: Teleprompter Grátis | Online, P2P, Celular e Notebook | Sem Instalação",
      description: "O teleprompter online GRATUITO mais rápido. Funciona no PC, Notebook e como teleprompter para celular ou iPhone. P2P, Zero Lag e sem apps para instalar.",
    },
    hero: {
      headline: "Teleprompter Profissional GRÁTIS Online. Grave olhando pra câmera, sem travar no texto",
      subheadline:
        "O texto rola no seu ritmo. Controle com o celular ou pela voz. Sem apps, sem complicação.",
      cta: "🚀 Teste Grátis Agora",
      startHint: "Comece aqui",
      ctaSecondary: "▶️ Ver Como Funciona",
      versionLive: "Versão 2.0 Online",
      userCount: "1.247",
      activeCreators: "Criadores ativos",
      freeTrial: "Teste grátis",
      zeroSetup: "Zero Setup. Sem Instalação.",
      offlineBadge: "Funciona Offline",
      privacyBadge: "Privacidade Total",
      smallphrase: "Sem cadastro • Funciona direto no navegador • Offline depois de instalar",
      p2pSection: {
        headline: "Sua rede local é o túnel. Zero atraso é a regra.",
        subheadline: "Esqueça o 'delay' de 3 segundos dos apps comuns. Com tecnologia WebRTC P2P, o que você aperta no celular acontece na tela no mesmo milissegundo.",
        badge: "⚡ Latência < 10ms",
      },
      privacySection: {
        headline: "Seus dados são seus. E só seus.",
        subheadline: "Sem contas, sem servidores, sem nuvem. O que você escreve no PromptNinja nunca sai do seu dispositivo. Privacidade por design, não por promessa.",
        badge: "🔒 Zero Tracking",
      },
      pwaSection: {
        headline: "Um app que não ocupa memória.",
        subheadline: "Instale o PromptNinja como um aplicativo nativo. Funciona offline, em tela cheia e carrega instantaneamente.",
        cta: "📱 Instalar App no Celular",
        guideCta: "Como instalar no iPhone/Android",
      },
    },
    problemSolution: {
      title: 'Chega de <span class="line-through text-red-500">frustração</span> ao gravar vídeos',
      before: {
        title: "Antes",
        items: [
          "😩 Esquecer o texto no meio do vídeo e ter que regravar tudo",
          "😤 Perder horas pausando e ajustando o roteiro manualmente",
          "🏃 Levantou 15 vezes para pausar/continuar o texto",
          "🤬 Tentar soluções caseiras que não funcionam direito",
          "💸 Gastar dinheiro em apps ou equipamentos que travam ou complicam",
          "📱 Baixar apps cheios de login, anúncios ou lag",
          "⚙️ Seu 'teleponto' físico é caro, sem compatibilidade ou só funciona com apps pagos.",
        ],
      },
      after: {
        title: "Agora",
        items: [
          "🎯 Falar olhando direto pra câmera, com naturalidade",
          "📱 Controlar play, pausa e velocidade pelo celular (zero delay)",
          "🗣️ O texto acompanha sua voz automaticamente",
          "🔒 Tudo privado: seus roteiros ficam só no seu dispositivo",
          "🌍 Funciona offline, em qualquer lugar (até sem internet)",
          "⏱️ Grave mais vídeos em menos tempo, sem regravar",
        ],
      },
    },
    howItWorks: {
      title: "Tão simples que até sua avó consegue",
      step1: {
        title: "Cole seu roteiro",
        desc: "Escreva ou cole o texto da sua apresentação no notebook",
      },
      step2: {
        title: "Escaneie o QR Code",
        desc: "Aponte a câmera do celular. Conexão automática em 2 segundos",
      },
      step3: {
        title: "Grave como um PRO",
        desc: "Controle a velocidade, pause, volte ao topo. Tudo pelo celular",
      },
      cta: "🚀 Começar Grátis",
    },
    comparison: {
      title: "Por que PromptNinja?",
      subtitle: "Comparação honesta com outras soluções",
      columns: {
        ninja: "PromptNinja",
        paid: "Apps Pagos",
        hardware: "Hardware",
        free: "Sites Grátis",
      },
      rows: {
        remote: "Controle Remoto",
        offline: "Funciona Offline",
        privacy: "Privacidade Total",
        latency: "Latência",
        price: "Custo Inicial",
      },
      values: {
        ninja: {
          remote: "Celular",
          offline: "Sim",
          privacy: "P2P",
          latency: "<10ms",
          price: "Grátis / R$ 67",
        },
        paid: {
          remote: "Não",
          offline: "Não",
          privacy: "Cloud",
          latency: "~100ms",
          price: "R$ 80/ano",
        },
        hardware: {
          remote: "Físico",
          offline: "Sim",
          privacy: "Sim",
          latency: "<5ms",
          price: "R$ 400+",
        },
        free: {
          remote: "Não",
          offline: "Não",
          privacy: "Rastreiam",
          latency: ">500ms",
          price: "Grátis c/ Ads",
        },
      },
    },
    features: {
      title: "Recursos",
      subtitle: "Tudo o que você precisa para um teleprompter profissional",
      badges: {
        free: "GRÁTIS",
        pro: "PRO",
      },
      sync: {
        title: "Sincronização Instantânea",
        desc:
          "Tecnologia P2P (Peer-to-Peer) garante controle em tempo real e sem atrasos. Sem latência de servidor, sua apresentação flui perfeitamente.",
      },
      offline: {
        title: "Modo Offline",
        desc:
          "Acesse seu teleprompter sem conexão. Seus roteiros permanecem privados, nunca saem do seu dispositivo.",
      },
      privacy: {
        title: "Privacidade Total",
        desc:
          "Seu roteiro é salvo apenas no seu navegador. Sem nuvem, sem servidores, garantindo privacidade total.",
      },
      voice: {
        title: "Recurso PRO: Controle por Voz",
        desc: "Destrave o Poder do Hands-Free. Deixe o roteiro rolar no seu ritmo de fala. Experimente o Free Trial.",
        cta: "Desbloqueie o Recurso PRO 🎤",
      },
      musician: {
        title: "Modo Músico",
        desc: "Rolagem de tela com letras e cifras perfeitamente alinhadas. Ideal para músicos que precisam acompanhar acordes e letras durante apresentações.",
        cta: "Saiba Mais sobre o Modo Música",
        cta2: "Acesse o Modo Música",
      },
      obs: {
        title: "Integração OBS Studio",
        desc: "Conecte diretamente ao OBS via WebSocket. Automatize suas gravações e troque cenas nativamente sem sair do teleprompter.",
      },
      themes: {
        title: "Temas Visuais",
        desc: "Modos Escuro, Claro, Matrix, Alto Contraste e Chroma Key (verde/azul) para gravações profissionais com fundo removível.",
      },
      pip: {
        title: "Modo Picture-in-Picture",
        desc: "Mantenha o teleprompter sempre visível em uma janela flutuante enquanto trabalha em outros aplicativos.",
      },
      recording: {
        title: "Gravação de Áudio",
        desc: "Grave a narração do seu roteiro e baixe o áudio para revisão, edição ou backup do seu conteúdo.",
      },
      pacing: {
        title: "Calculadora de Tempo",
        desc: "Calcule o tempo estimado de leitura do seu roteiro (WPM). Ajuste o texto para caber em 60 segundos (TikTok/Reels) ou 5 minutos (YouTube). Produza conteúdo otimizado para cada plataforma.",
      },
      shortcuts: {
        title: "Atalhos de Teclado",
        desc: "Controle total via teclado, ou use comandos de texto como STOP e PAUSE para controle automático no script.",
      },
      bilingual: {
        title: "Novo: Modo Bilíngue",
        desc: "Visualize dois idiomas lado a lado. Perfeito para aprender novas línguas ou para apresentações internacionais. Use o controle de voz para rastrear o idioma da sua escolha.",
        cta: "Conhecer o Modo Bilíngue 🌐",
      },
      focus: {
        title: "Foco Dinâmico",
        desc:
          "Linha de foco dinâmico: O destaque inteligente segue sua leitura, garantindo que você nunca perca o fio.",
      },
      master: {
        title: "Gerenciamento Multi-Teleprompter",
        desc:
          "Administre diversos teleprompter em um hub central. Perfeito para eventos com múltiplos apresentadoress",
      },
    },
    pricing: {
      title: "Preço Simples e Honesto",
      subtitle: "Teste grátis, atualize quando quiser",
      free: {
        title: "Grátis",
        desc: "Para testar e validar",
        price: "R$ 0",
        period: "/sempre",
        cta: "Começar Grátis",
        features: ["20 minutos por sessão", "Sessões ilimitadas", "Controle remoto total", "Todos os temas", "Integração OBS (Básico)"],
        missing: ["Sessões sem limites de tempo", "Controle por voz", "Customizar Atalhos", "Integração OBS", "Gerenciamento Multi-Teleprompter"],
      },
      pro: {
        badge: "🔥 PREÇO DE LANÇAMENTO",
        title: "PRO Vitalício",
        desc: "Pagamento único, seu para sempre",
        price: "R$ 67",
        originalPrice: "R$ 147",
        priceNote: "Depois vira R$ 12,90/mês ou R$ 147 vitalício",
        cta: "🚀 Garantir Acesso Vitalício",
        timer: "⏰ Preço válido apenas para os primeiros 500 usuários",
        features: [
          "Sessões ilimitadas (sem tempo)",
          "Sem marca d'água",
          "Múltiplos controles remotos (equipes)",
          "Controle por voz",
          "Suporte prioritário",
          "Suporte MIDI para controladores físicos",
          "Acesso antecipado a features",
          "Customizar Atalhos de Teclado",
          "Integração OBS (WebSocket)",
          "Gerenciamento Multi-Teleprompter para Eventos",
        ],
      },
      paymentInfo:
        "💳 Pagamento único via Cartão, PIX ou Boleto\n🔒 Garantia de 7 dias (devolução sem perguntas)",
      // Keep old keys for backward compatibility if needed during transition
      lifetime: "Vitalício",
      oneTime: "pagamento único",
      limitedOffer: "Oferta Limitada",
      conversionNotice: "",
    },
    faq: {
      title: "Perguntas Frequentes",
      items: [
        {
          q: "Preciso instalar algum app?",
          a: "Não! Funciona 100% no navegador. Abra no notebook, escaneie com o celular, e pronto. É um PWA, então você PODE instalar se quiser.",
        },
        {
          q: "Funciona sem internet?",
          a: "Sim! A conexão é P2P. Se ambos estiverem na mesma rede Wi-Fi ou se você já abriu o app antes, funciona offline.",
        },
        {
          q: "O PromptNinja armazena meus dados?",
          a: "Não. Usamos tecnologia P2P para manter seus dados e scripts localmente em seus dispositivos. Sua privacidade é total.",
        },
        {
          q: "O que acontece após 20 minutos na versão grátis?",
          a: "Aparece um convite para upgrade. Você pode iniciar uma nova sessão sem limites diários.",
        },
        {
          q: "Funciona em qual navegador?",
          a: "Chrome, Edge, Safari e Firefox. Recomendamos Chrome pela melhor compatibilidade.",
        },
        {
          q: "E se eu não gostar?",
          a: "Garantia de 7 dias. Devolvemos 100% sem perguntas.",
        },
      ],
    },
    finalCta: {
      title: "Pronto para gravar como um profissional?",
      subtitle: "Junte-se aos criadores que já pararam de regravar 15 vezes o mesmo vídeo",
      ctaPrimary: "Começar Grátis (20 min)",
      ctaSecondary: "Ver Preços",
      footer: "Sem cartão de crédito. Sem instalação. Sem enrolação.",
    },
  },
  status: {
    disconnected: "DESCONECTADO",
    connecting: "CONECTANDO...",
    connected: "CONECTADO",
    error: "ERRO DE REDE",
  },
  host: {
    startPrompter: "Iniciar Teleprompter",
    editText: "Editar Roteiro",
    mirror: "Espelhar",
    mirrorV: "Espelhar Verticalmente",
    remoteConnect: "Conectar Controle Remoto",
    scanInstruction: "Escaneie o QR Code para Controlar",
    generatingId: "Gerando Link...",
    idLabel: "ID da Sessão:",
    editorPlaceholder: "Cole ou digite seu roteiro aqui para uma apresentação impecável...",
    musicEditorPlaceholder: `🎵 Cole sua cifra ou letra aqui...
    
[Am]      [F]
Letras e acordes
[C]       [G]
Alinhados perfeitamente`,
    localhostWarning: "Atenção: Você está em localhost. Para usar o controle remoto, abra em outra aba.",
    offlineWarning: "Você está offline. O teleprompter funciona normalmente, mas a inicialização do controle remoto P2P requer conexão com a internet.",
    openRemoteTab: "Abrir Controle Remoto (Nova Aba)",
    copyLink: "Copiar Link",
    linkCopied: "Copiado!",
    connectionLost: "Conexão Perdida com o Teleprompter",
    watermark: "PromptNinja - Versão Gratuita",
    controls: {
      play: "Reproduzir",
      pause: "Pausar",
      reset: "Reiniciar",
      speed: "Velocidade de Rolagem",
      margin: "Margem",
      size: "Tamanho do Texto",
      timer: "Temporizador",
      caps: "Maiúsculas",
      voice: "Controle por Voz",
      focusLine: "Linha de Foco Dinâmico",
      theme: "Tema Visual do Teleprompter",
      fontSize: "Tamanho da Fonte",
      fontWeight: "Espessura da Fonte",
      isMirrored: "Espelhar Horizontalmente",
      display: "Exibição",
      chroma: "Chroma Key",
      record: "Gravar",
      voiceLanguage: "Idioma de Voz",
      stopRecord: "Parar Gravação",
      downloadRecord: "Baixar Gravação",
      recordNew: "Gravar Novo",
      fontConfig: "Configurar Fonte",
      appearance: "Aparência",
      prevPart: "Voltar",
      nextPart: "Avançar",
      livePreview: "Visualizar",
      done: "Feito",
      livePreviewHelp: "Modifique para visualizar",
    },
    hudLabels: {
      theme: "Tema",
      focus: "Foco",
      voice: "Voz",
      display: "Exibição",
      chroma: "Chroma Key",
    },
    themes: {
      default: "Padrão",
      ninja: "Ninja (Tema Escuro)",
      paper: "Papel (Tema Claro)",
      contrast: "Alto Contraste",
      matrix: "Matrix",
      cyber: "Cyberpunk (Tecnológico)",
      cream: "Creme (Conforto Visual)",
      chroma_green: "Chroma Key (Verde)",
      chroma_blue: "Chroma Key (Azul)",
      transparent: "Transparente",
    },
    tips: {
      title: "Dicas PRO para Edição e Performance",
      desc: "Aproveite as tags para destacar seu texto:",
      red: "Destaque em Vermelho",
      yellow: "Destaque em Amarelo",
      green: "Destaque em Verde",
      caps: "Use o botão 'TT' para ativar o modo MAIÚSCULAS e dar ênfase.",
      voice: "Ative o microfone para rolagem automática por voz e mantenha o ritmo da sua fala.",
    },
    paywall: {
      title: "Recurso Exclusivo PRO",
      unlock: "Desbloquear PRO",
      desc:
        "Desbloqueie o poder total do PromptNinja! Funcionalidades PRO incluem controle por voz, configurar atalhos e uso ilimitado.",
      cta: "Desbloquear Acesso Vitalício PRO",
      inputPlaceholder: "Insira sua chave de acesso PRO...",
      button: "Ativar Versão PRO",
      invalid: "Chave PRO Inválida",
      success: "PromptNinja PRO Ativado com Sucesso!",
      emptyKey: "Por favor, insira uma chave de desbloqueio.",
      invalidKey: "Chave de desbloqueio inválida. Tente novamente.",
      countdownMessage: "Retornando à página em...",
      trialButton: "Testar Modo PRO por 24 horas",
      deviceLimit: "Limite de 12 dispositivos atingido. Se você trocou de aparelho ou formatou o PC, contate o suporte para resetar seus acessos.",
      notFound: "Chave não encontrada. Verifique se digitou corretamente ou cheque seu e-mail da Kiwify (spam inclusive).",
      contactSupport: "Falar com Suporte (WhatsApp)",
      trialActive: "Modo PRO (Trial) Ativo",
      close: "Fechar",
      maybeLater: "Talvez depois",
      freeAlternativeTitle: "Use GRÁTIS e Nos Ajude!",
      leaveReviewCta: "⭐ Continuar Usando Grátis e Deixar 5 Estrelas no Google",
      faltam: "Faltam",
      feedbackQuestion: "Tem críticas ou sugestões?",
      feedbackAction: "Dê seu feedback",
      trialExpiredTitle: "Ninja por um dia!",
      trialExpiredDesc: "Esperamos que o seu dia de Ninja tenha sido produtivo! Suas configurações foram salvas, mas os recursos Pro agora estão bloqueados. Garanta o acesso vitalício para continuar evoluindo.",
    },
    voice: {
      notSupported: "Seu navegador não suporta controle por voz",
    },
    exit: "Sair",
    masterMode: "Gerenciamento Multi-Teleprompter",
    masterPanel: "Entrar no Painel de Controle",
    editor: {
      highlight: "Destaque",
      musicianMode: "Modo Músico",
      bilingualMode: "Modo Bilíngue",
      bold: "Negrito (Ctrl+B)",
      italic: "Itálico (Ctrl+I)",
      underline: "Sublinhado (Ctrl+U)",
    },
    autocomplete: {
      title: "Comandos Sugeridos",
      navigate: "Navegar",
      select: "Selecionar",
      results: "resultados",
      suggestions: {
        speed: { label: "VELOCIDADE", desc: "Altera a velocidade (Ex: [SPEED 5])" },
        pause: { label: "PAUSA", desc: "Pausa por X segundos (Ex: [PAUSE 5])" },
        stop: { label: "PARAR", desc: "Para a rolagem (Ex: [STOP])" },
        loop_start: { label: "LOOP INÍCIO", desc: "Inicia um trecho de repetição" },
        loop_end: { label: "LOOP FIM", desc: "Termina o loop com X voltas (Ex: [LOOP 5])" },
        part: { label: "PARTE", desc: "Marca uma divisão do roteiro" },
        bpm: { label: "BPM", desc: "Ajusta o BPM (Ex: [BPM 120] ou [BPM AUTO])" },
        count: { label: "CONTAGEM", desc: "Cronômetro regressivo (Ex: [COUNT 10])" },
        rest: { label: "DESCANSO", desc: "Tempo de intervalo (Ex: [REST 15])" },
      }
    },
    defaultText: `Bem-vindo ao PromptNinja.

Clique em PLAY e leia olhando para a câmera.

O teleprompter definitivo para criadores de conteúdo.

1. Escaneie o QR Code para conectar.
2. Controle a velocidade de rolagem com facilidade.
3. Use o Trackpad para navegação intuitiva.

<r>ATENÇÃO:</r>
Use as tags de cor para destacar momentos importantes no seu roteiro.
<y>Este texto está em amarelo para ênfase leve.</y>
<g>E este em verde para sinalizar calma ou uma transição suave.</g>

Cole seu roteiro aqui e personalize sua experiência para começar a brilhar!`,
    ndi: {
      toggleLabel: "Saída NDI (OBS/Vmix)",
      toggleDesc: "Transmissão via Captura de Tela",
      tutorial: {
        title: "Guia de Configuração NDI",
        step1: "Abra o <b>vdo.ninja</b> em uma nova aba.",
        step2: "Selecione 'Remote Screenshare'.",
        step3: "No OBS, adicione 'Browser Source' com o link do VDO.",
        step4: "Alternativa: Use 'Captura de Janela' do OBS direto.",
        cleanMode: "Modo Limpo (Sem HUD)",
        vingesterConfig: "Para NDI nativo, use o app Vingester.app",
        openVdo: "Abrir VDO.Ninja",
        close: "Fechar",
        cleanModeBtn: "Reiniciar em Modo Limpo (?hud=0)",
        masterMode: "Modo Master (Pro)",
        masterPanel: "Painel Master",
      }
    }
  },

  bilingual: {
    mode: "Modo Bilíngue",
    primaryLanguage: "Idioma Principal (Língua 1)",
    secondaryLanguage: "Idioma Secundário (Língua 2)",
    primaryPlaceholder: "Cole o texto no idioma principal aqui...",
    secondaryPlaceholder: "Cole o texto no idioma secundário aqui...",
    voiceTrackLabel: "Controle de Voz Rastreia:",
    voiceTrackPrimary: "Idioma Principal",
    voiceTrackSecondary: "Idioma Secundário",
    description: "Exiba dois textos lado a lado para estudar idiomas ou apresentações multilíngues.",
    columnInfo: "As duas colunas serão exibidas lado a lado com proporção 50/50.",
    alignmentTip: "Dica: Use [ALIGN]palavra[/ALIGN] em ambos os textos para sincronizar palavras específicas durante o scroll.",
    trackLanguage: "Rastrear este idioma (Controle por Voz)",
    tracking: "Controle de voz ativo nessa aba",
    landscapeTip: "💡 Para melhor experiência em celular, gire para o modo paisagem (horizontal)",
    languages: {
      pt: "Português",
      en: "Inglês",
      es: "Espanhol",
      it: "Italiano",
      fr: "Francês",
      de: "Alemão",
      ja: "Japonês",
      zh: "Chinês",
      other: "Outro",
      auto: "Automático (Idioma do Site)"
    },
  },
  pacing: {
    title: "Calculadora de Tempo de Leitura",
    wordCount: "Palavras",
    estimatedTime: "Tempo Estimado",
    wpmLabel: "Palavras por Minuto (WPM)",
    slow: "Lento (120 WPM)",
    medium: "Médio (150 WPM)",
    fast: "Rápido (180 WPM)",
    totalWithPauses: {
      title: "Tempo Total",
      details: "Sem pausas -",
      pauses: "Com pausas -",
    },
    platforms: {
      title: "Recomendações por Plataforma",
      tiktok: "TikTok/Reels (60s)",
      youtube: "YouTube (5 min)",
    },
    suggestions: {
      tooLong: "Seu roteiro está longo. Considere reduzir para ~{{words}} palavras.",
      tooShort: "Seu roteiro está curto. Considere adicionar ~{{words}} palavras.",
      perfect: "Perfeito!",
    },
    custom: {
      title: "WPM Personalizado",
      label: "Sua Velocidade (WPM)",
      result: "Tempo Estimado",
    },
    button: "Calcular Tempo",
  },
  remote: {
    connecting: "Buscando Conexão com o Teleprompter...",
    targetId: "Teleprompter Conectado: {{id}}",
    touchArea: "Área de Controle Remoto",
    speed: "Velocidade",
    reset: "Reiniciar",
    start: "Iniciar",
    pause: "Pausar",
    stop: "Parar",
    theme: "Tema",
    language: "Idioma",
    bilingualEditTitle: "Edição Bloqueada",
    bilingualEditWarning: "A edição está desativada no modo bilíngue. Use o computador principal.",
    scanError: "Falha ao acessar a câmera. Verifique as permissões ou se está usando HTTPS.",
    iosMicGuidance: {
      title: "Dica para iOS/Safari",
      description: "Para evitar pedidos repetidos de permissão, toque no ícone 'AA' na barra de endereços, selecione 'Ajustes do Site' ou '...' e mude 'Microfone' para 'Permitir'.",
      button: "Como configurar",
      step1: "Toque no ícone 'AA' na barra de endereços",
      step2: "Selecione 'Ajustes do Site' ou '...' e mude 'Microfone' para 'Permitir'",
    },
    voicePermission: {
      title: "Microfone Bloqueado",
      description: "O Safari bloqueou o acesso. Clique abaixo para tentar reativar ou siga a dica nos ajustes.",
      action: "Tentar Novamente",
    },
    proFeature: "Recurso PRO",
  },
  share: {
    button: "Compartilhar PromptNinja",
    title: "Compartilhe o PromptNinja!",
    text: "Meus vídeos estão perfeitos! 🎬 Descobri o PromptNinja - teleprompter online, GRÁTIS, P2P e sem atrasos. Uso meu celular como controle remoto!",
    success: "Obrigado por compartilhar! ❤️",
    notSupported: "Compartilhamento não disponível neste navegador",
    cardTitle: "Compartilhar",
    cardDescription: "Gostou do PromptNinja? Compartilhe com amigos e ajude outros criadores!",
  },
  tutorial: {
    tips: {
      title: "Dicas Pro",
      tip1: "Use o controle por voz para operação mãos-livres.",
      tip2: "Escaneie o código QR para controlar do seu telefone.",
    },
    title: "PromptNinja: Guia de Início Rápido",
    overview: {
      title: "Visão Geral do Teleprompter",
      description:
        "PromptNinja: o teleprompter profissional P2P que transforma seu navegador em um estúdio completo e seu smartphone em um controle remoto intuitivo. Sem apps, contas ou servidores, garantindo privacidade e controle total.",
    },
    howToUse: {
      title: "Como Usar o PromptNinja",
      step1: {
        title: "1. Prepare seu Roteiro",
        description:
          "No editor, digite ou cole o texto da sua apresentação. Utilize tags como <r>texto</r> para destacar palavras ou frases com cores vibrantes.",
      },
      step2: {
        title: "2. Conecte seu Smartphone como Controle Remoto",
        description:
          "Escaneie o QR Code exibido na tela com seu smartphone para transformá-lo em um controle remoto. Ajuste a velocidade de rolagem, inicie e pause sua apresentação com facilidade.",
      },
      step3: {
        title: "3. Inicie sua Apresentação",
        description:
          "Clique em 'Iniciar Teleprompter' para ativar o modo de apresentação. Gerencie a rolagem do texto usando seu controle remoto ou o inovador controle por voz.",
      },
    },
    advancedFeatures: {
      title: "Recursos Avançados do Teleprompter",
      voiceControl: {
        title: "Controle por Voz (Exclusivo PRO)",
        description:
          "Ative o controle por voz para que o teleprompter acompanhe automaticamente o ritmo da sua fala. Este recurso avançado requer a versão PRO.",
      },
      themes: {
        title: "Temas Visuais Personalizáveis",
        description:
          "Personalize a aparência do seu teleprompter com uma variedade de temas visuais, garantindo a melhor legibilidade em qualquer ambiente e condição de iluminação.",
      },
      focusMode: {
        title: "Modo Foco Dinâmico",
        description:
          "Ative o modo de foco dinâmico para destacar a linha de texto atual, auxiliando você a manter a concentração e a fluidez durante a leitura.",
      },
      noControls: {
        title: "Modo Sem Controles",
        description:
          "Para uma experiência mais limpa, ative o modo sem controles (HUD-less). A interface some, mas você continua controlando tudo pelo celular ou atalhos de teclado.",
      },
      musicianMode: {
        title: "Modo Músico",
        description:
          "Ideal para cifras e letras. Este modo mantém a formatação original e evita quebras de linha indesejadas, perfeito para tocar e cantar.",
      },
      bilingualMode: {
        title: "Modo Bilíngue",
        description:
          "Exiba dois textos lado a lado. Ideal para aprendizagem de idiomas ou apresentações multilíngues. Inclui controle de voz selecionável.",
      },
    },
    commands: {
      title: "Comandos de Texto Inteligentes",
      subtitle: "Automatize seu roteiro com comandos entre colchetes",
      speed: {
        title: "Velocidade Dinâmica",
        desc: "Altere a velocidade de rolagem automaticamente.",
        example: "[SPEED 5]",
      },
      loop: {
        title: "Loop / Repetição",
        desc: "Crie loops para exercícios ou refrões. Repete o trecho entre START e o número de vezes definido.",
        example: "[LOOP START] ... [LOOP 3]",
      },
      pause: {
        title: "Pausa Programada",
        desc: "Pausa a rolagem por X segundos e retoma automaticamente.",
        example: "[PAUSE 5]",
      },
      stop: {
        title: "Parar",
        desc: "Pare a rolagem automaticamente.",
        example: "[STOP]",
      },
      next: {
        title: "Avançar ou Voltar",
        desc: "Avança ou volta para a próxima parte. Use atalhos do teclado ( →, ←).",
        example: "[PART X] [SLIDE X]",
      },
      count: {
        title: "Contagem",
        desc: "Contagem de repetições. Ideal para exercícios (feito para integração com controle de voz).",
        example: "[COUNT 10]",
      },
      rest: {
        title: "Descanse",
        desc: "Descanse por X segundos e retoma automaticamente. Ideal para exercícios.",
        example: "[REST 5]",
      },
    },
  },
  script: {
    manager: "Roteiros",
    yourScripts: "Seus Roteiros",
    untitled: "Roteiro Sem Título",
    new: "Novo Roteiro",
    rename: "Renomear Roteiro",
    deleteConfirm: "Tem certeza que deseja excluir este roteiro?",
    trash: "Lixeira",
    emptyTrash: "Sua lixeira está vazia",
    restore: "Restaurar",
    permanentlyDelete: "Excluir permanentemente",
    autoCleanupNote: "Scripts são excluídos automaticamente após 14 dias",
  },
  paywall: {
    title: "Customizar Atalhos de Teclado",
    unlock: "Desbloquear PRO",
  },
  footer: {
    copyright: "PromptNinja. Todos os direitos reservados.",
    links: {
      resources: "Recursos",
      oratory: "Dicas de Oratória",
      alternatives: "Alternativas",
      whatIs: "O Que É Teleprompter",
    },
  },
  editor: {
    findReplace: "Localizar e Substituir",
    find: "Procurar",
    findPlaceholder: "Digite o texto para buscar...",
    replacePlaceholder: "Digite o texto para substituir...",
    replaceWith: "Substituir por",
    replace: "Substituir",
    findNext: "Procurar Próximo",
    replaceAll: "Substituir Tudo",
    undo: "Desfazer",
    matches: "resultados",
    cleanText: "Limpar Texto",
    removeLineBreaks: "Remover Quebras de Linha",
  },
  thankYou: {
    title: "Obrigado pela compra!",
    subtitle:
      "Seu pagamento foi confirmado com sucesso. Agora você está a um passo de desbloquear todo o poder do PromptNinja Pro.",
    success: {
      title: "PromptNinja Pro Ativado!",
      message: "Sua conta foi atualizada com sucesso. Aproveite todos os recursos ilimitados.",
      button: "Começar a Usar Agora",
    },
    activation: {
      title: "Ativar sua licença",
      description:
        "Insira o código de ativação que você recebeu no seu e-mail (ou na página de confirmação da Kiwify).",
      label: "Código de Ativação",
      placeholder: "INSIRA SEU CÓDIGO AQUI",
      button: "Ativar PromptNinja Pro",
      validating: "Validando...",
      skip: "Pular ativação e ir para o App Gratuito",
      error: {
        invalid: "Código inválido ou já utilizado.",
        connection: "Erro de conexão. Verifique sua internet e tente novamente.",
      },
    },
    footer: "© {{year}} PromptNinja. Todos os direitos reservados.",

  },
  seo: {
    scripts: {
      title: "Scripts Prontos para Teleprompter",
      description: "Coleção completa de roteiros gratuitos para seus vídeos.",
    },
  },
  hudless: {
    button: "Esconder Controles",
    tooltip: "Inicia o teleprompter sem interface visível. Controle via celular ou teclas.",
    showControls: "Mostrar Controles",
  },
  hotkeys: {
    title: "Atalhos de Teclado",
    proDescription: "Customizar atalhos é um recurso PRO.",
    reset: "Restaurar Padrões",
    pressKey: "Pressione a tecla...",
    actions: {
      TOGGLE_PLAY: "Play / Pause",
      SPEED_UP: "Aumentar Velocidade",
      SPEED_DOWN: "Diminuir Velocidade",
      FONT_INCREASE: "Aumentar Fonte",
      FONT_DECREASE: "Diminuir Fonte",
      TOGGLE_MIRROR: "Espelhar",
      TOGGLE_FLIP: "Inverter Vertical",
      TOGGLE_FOCUS: "Modo Foco",
      EXIT: "Sair",
      RESET: "Reiniciar",
      TOGGLE_HUD: "Mostrar/Ocultar Interface",
      TOGGLE_CAMERA: "Alternar Câmera",
      TOGGLE_WIDGET: "Mini-Janela (PiP)",
      NEXT_PART: "Avançar Parte",
      PREVIOUS_PART: "Voltar Parte",
      FORMAT_BOLD: "Formatar Negrito",
      FORMAT_ITALIC: "Formatar Itálico",
      FORMAT_UNDERLINE: "Formatar Sublinhado",
      FORMAT_RED: "Cor: Vermelho",
      FORMAT_YELLOW: "Cor: Amarelo",
      FORMAT_GREEN: "Cor: Verde",
      FORMAT_BLUE: "Cor: Azul",
    },
  },
  voice_analytics: {
    title: "Apresentação Concluída",
    congratulations: "Incrível! Você terminou o script.",
    subtitle: "Aqui está o resumo do seu desempenho nesta sessão:",
    duration: "Duração",
    wpm: "WPM (Velocidade)",
    accuracy: "Precisão",
    sentences: "Frases",
    close: "Fechar Resumo",
  },
  music: {
    bpmSync: "BPM",
    backingTrackUpload: "Adicionar Backing Track",
    bpmTeaser: "Auto-sync com microfone (detecta batidas reais) exclusivo PRO → R$ 67 vitalício",
    hero: {
      badge: "Modo Palco",
      headline: "Teleprompter para Músicos:",
      subHeadline: "Setlists Infinitas, Zero Lag e Controle por Pedal",
      description: "Crie setlists com rolagem automática, sync BPM e P2P via celular. Perfeito para bandas independentes, sem travar no palco.",
      cta: "Crie Sua Setlist Grátis Agora",
      ctaSecondary: "Veja em Ação",
    },
    features: {
      headline: "Tudo para o seu Show",
      subheadline: "Ferramentas essenciais para ensaios e apresentações ao vivo.",
      setlist: {
        title: "Setlists Personalizadas",
        desc: "Adicione e reordene músicas livremente. Edite cifras com fonte monoespaçada para alinhamento perfeito.",
      },
      offline: {
        title: "Offline PWA",
        desc: "Instale no tablet ou PC. Funciona sem internet garantindo estabilidade total no palco.",
      },
      themes: {
        title: "Modo Noturno (Stage Mode)",
        desc: "Fundo escuro e letras contrastantes. Perfeito para ambientes com pouca luz sem ofuscar sua visão.",
      },
      lyrics: {
        title: "Zero Lag P2P",
        desc: "Controle remoto via celular com resposta instantânea. Estabilidade essencial para shows longos.",
      },
      pedal: {
        title: "Pedais e Hotkeys",
        desc: "Atalhos nativos para Page Up/Down. Compatível com pedais bluetooth para controle com os pés.",
      },
      bpm: {
        title: "BPM Sync",
        desc: "Rolagem automática no ritmo da banda. Escuta o som ao vivo ou sincroniza com o metrônomo.",
      },
      backingSync: {
        title: "Sync com Backing Tracks",
        desc: "Markers e Preview de 15s. Sincronize o texto com seu áudio guia ou backing track.",
      },
      voice: {
        desc: "Deixe o PromptNinja virar a página pra você. O reconhecimento de voz acompanha o canto.",
      },
      pro: {
        desc: "Desbloqueie MIDI customizável, setlists infinitos e uso em múltiplos dispositivos.",
      },
    },
    landing: {
      meta: {
        title: "Teleprompter Grátis para Músicos: Setlists Infinitas, BPM Auto & Sync Backing | PromptNinja Music",
        description: "O melhor teleprompter para músicos. Crie setlists, role cifras e letras automaticamente com Sync de Backing Tracks e Auto BPM via Microfone.",
        keywords: "teleprompter para músicos, teleprompter de cifras, app de setlist, letras e cifras, scrolagem automática, teleprompter palco, promptninja music, backing track sync",
      },
      pwa: {
        title: "Instale no Seu Tablet de Palco",
        subtitle: "Offline, Rápido e Sem Atrair Notificações.",
        cta: "Instalar App de Palco",
      },
      faq: {
        title: "Dúvidas de Músicos",
        items: [
          {
            q: "Como syncar com pedal?",
            a: "O PromptNinja reconhece nativamente teclas como PageUp, PageDown, Home e End que são o padrão da maioria dos pedais bluetooth (inclusive genéricos). Basta parear e usar.",
          },
          {
            q: "Funciona para setlists de 30 músicas?",
            a: "Sim! Você pode criar setlists ilimitadas. O carregamento é instantâneo pois tudo roda localmente no seu navegador.",
          },
          {
            q: "Qual a diferença para apps como Cube Turner?",
            a: "O PromptNinja é focado em ser cross-platform (roda em qualquer lugar) e possui o controle remoto P2P único, permitindo que outro integrante da banda controle a letra pelo celular se necessário.",
          },
          {
            q: "Preciso de internet no show?",
            a: "Não. Recomendamos carregar a página uma vez com internet. Depois disso, ele funciona 100% offline (PWA).",
          }
        ]
      },
      cta: {
        title: "Pronto para Seu Próximo Show?",
        subtitle: "Mais de 500 músicos já usam o PromptNinja no palco.",
        ctaPrimary: "Teste Grátis no Ensaio",
        ctaSecondary: "Ver Planos PRO",
        footer: "Simples. Rápido. Feito pra quem toca.",
      },
      pricing: {
        title: "PRO Vitalício por R$ 67",
        subtitle: "Pagamento único, seu para sempre. Focado em performance de palco.",
        badge: "OFERTA MÚSICO",
        features: [
          "Setlists Ilimitadas",
          "Backing Track Sync (Sem Limites)",
          "Auto BPM via Microfone",
          "Controle MIDI Customizado",
          "Offline PWA (App de Palco)",
          "Suporte a Pedais Bluetooth",
          "Zero Logos / Marca d'água",
          "Acesso Vitalício (Sem Mensalidade)"
        ],
        price: "R$ 67",
        priceNote: "Preço único promocional para músicos.",
        timer: "⏰ Garanta seu lugar no palco com desconto"
      },
    },
    footer: {
      backToGeneral: "Voltar para Teleprompter Geral",
    },
    backingTrack: {
      remove: "Remover",
      largeFile: "Arquivo muito grande. Limite de 50MB.",
      error: "Falha no upload do áudio.",
      preview: "Preview (10s)",
      syncActive: "Sincronização com Áudio Ativa",
    },
  },
  midi: {
    title: "Configurar MIDI",
    enabled: "Ativar Modo MIDI",
    disabled: "Desativar Modo MIDI",
    pressPedal: "Pressione o pedal ou tecla...",
    mapping: "Mapeamento MIDI",
    actions: {
      TOGGLE_PLAY: "Play / Pause",
      NEXT_SONG: "Próxima Música / Parte",
      PREV_SONG: "Música / Parte Anterior",
      START_SCROLL: "Iniciar Rolagem",
      STOP_SCROLL: "Parar Rolagem",
      SPEED_UP: "Aumentar Velocidade",
      SPEED_DOWN: "Diminuir Velocidade",
      FONT_INCREASE: "Aumentar Fonte",
      FONT_DECREASE: "Diminuir Fonte",
      RESET: "Reiniciar",
      TOGGLE_MIRROR: "Espelhar",
      EXIT: "Sair",
    },
    proDescription: "A conexão com pedais MIDI e OBS Studio é exclusiva para membros PRO.",
  },

  obs: {
    title: "Integração OBS Studio",
    connect: "Conectar",
    disconnect: "Desconectar",
    statusConnected: "Conectado",
    statusDisconnected: "Desconectado",
    host: "Host / IP",
    port: "Porta",
    password: "Senha",
    automation: "Automação Ninja",
    autoRecord: "Gravar no OBS ao dar Play",
    autoPlay: "Dar Play ao gravar no OBS",
    errorConnection: "Falha ao conectar. Verifique se o OBS WebSocket (v5) está ativado.",
  },

  onboarding: {
    title: "Seja bem-vindo ao PromptNinja! 🥷",
    subtitle: "Sua jornada para vídeos impecáveis começa agora",
    cta: "Próximo",
    finish: "Começar Agora!",
    skip: "Pular Tour",
    steps: [
      {
        title: "Olhe para a Câmera",
        desc: "Leia seu roteiro mantendo contato visual perfeito. O PromptNinja foi desenhado para você falar com naturalidade, sem esquecer o texto.",
        icon: "camera"
      },
      {
        title: "Seu Celular é o Controle",
        desc: "Use nosso P2P com zero atraso. Escaneie o QR Code com seu celular e controle tudo à distância: velocidade, play e pause.",
        icon: "remote"
      },
      {
        title: "Poder Ninja (PRO)",
        desc: "Domine o palco com o Controle por Voz, atalhos personalizados e sessões ilimitadas. Transforme seu navegador em um estúdio completo.",
        icon: "pro"
      }
    ]
  },
  master: {
    title: "MODO MASTER",
    subtitle: "Controle Múltiplos Teleprompters",
    exampleTitle: "Roteiro Exemplo",
    exampleContent: "Bem-vindo ao Modo Evento do PromptNinja!\n\nEste é o seu painel central.",
    connectDisplay: "Conectar Display",
    idPlaceholder: "Digite o ID do display...",
    add: "ADICIONAR",
    connectedDisplays: "DISPLAYS CONECTADOS",
    noDisplays: "Nenhum display conectado. Adicione um ID acima para começar.",
    globalControl: "CONTROLE GLOBAL",
    playAll: "PLAY EM TODOS",
    pauseAll: "PAUSE EM TODOS",
    resetAll: "REINICIAR TODOS",
    scriptLibrary: "BIBLIOTECA DE ROTEIROS",
    noScripts: "Nenhum roteiro salvo no banco local.",
    createScriptsHint: "Crie roteiros para enviar aos seus displays remotamente.",
    selectedScript: "Roteiro Selecionado",
    deployHint: "Escolha para qual(is) display(s) deseja enviar este texto:",
    confirmDelete: "Deseja mesmo remover?",
    pushAll: "ENVIAR PARA TODOS",
    editingLocal: "Editando Roteiro Local",
    scriptTitle: "Título do Roteiro",
    scriptContent: "Conteúdo do roteiro...",
    saveChanges: "SALVAR ALTERAÇÕES",
    limitReached: "Limite atingido: Apenas 1 controle remoto no plano gratuito. Atualize para Pro!",
    displayActions: {
      play: "Play",
      pause: "Pause",
      edit: "Editar",
      remove: "Remover",
      push: "Push",
    }
  }
};

